import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "new-chat"
};
const _hoisted_2 = {
  class: "box-center"
};
const _hoisted_3 = {
  class: "btns"
};
export default /*@__PURE__*/_defineComponent({
  __name: 'MessageNewConversation',
  emits: ['onNewConversation'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    /** 新建 conversation 聊天对话 */
    const handlerNewChat = () => {
      emits('onNewConversation');
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "tip"
      }, "点击下方按钮，开始你的对话吧", -1)), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
        type: "primary",
        round: "",
        onClick: handlerNewChat
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode("新建对话")])),
        _: 1
      })])])]);
    };
  }
});